import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC6sqHXI1v7sQdrbo4Jmsb1C84VaShCDPY",
  authDomain: "cheongdamsecret.firebaseapp.com",
  projectId: "cheongdamsecret",
  storageBucket: "cheongdamsecret.firebasestorage.app",
  messagingSenderId: "801453366241",
  appId: "1:801453366241:web:9720b1805ef75a003350a0",
  measurementId: "G-JPGD91E92S",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const vapidKey = "BLdAx1__clPuzHM-pkbc6-oSCIuINaM4k4DogFBGUC0C4idsL1lJiSDBFDpODS_V56ONNLoLFnNKpn5LP4KCgcs";

// Function to request notification permission and get the FCM token
export const requestForToken = async (): Promise<string | null> => {
  try {
    const permission = await Notification.requestPermission();
    console.log("Permission: ", permission);
    
    if (permission === "granted") {
      const currentToken = await getToken(messaging, { vapidKey });
      if (currentToken) {
        console.log("FCM Token:", currentToken);
        return currentToken;
      } else {
        console.warn("No registration token available. Request permission to generate one.");
        return null;
      }
    } else {
      console.warn("Notification permission not granted.");
      return null;
    }
  } catch (error) {
    console.error("An error occurred while retrieving the token:", error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Message received: ", payload);
      resolve(payload);
    });
  });

export { app, messaging };
